import Modal from "react-modal";
import "./custom_modal.scss";
import IconCloseImage from "../../assets/icons/icon_close_image.svg";
import Button from "../button";

const styleNoHeader = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "0px",
    borderRadius: "10px",
    backgroundColor: "transparent",
    border: "1px solid rgba(0, 0, 0, 0.0)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
};
const styleWithHeader = {
  content: {
    // width: '50vw',
    // height:'60vh',
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#ffffff",
    borderRadius: "24px",
    border: "1px solid #ccc",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
};

Modal.setAppElement("#root");

const CustomModalMaster = (props) => {
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
      style={props.withHeader ? styleWithHeader : styleNoHeader}
      contentLabel={props.contentLabel}
    >
      <div
        className="modal-header"
        style={{ display: props.withHeader ? "block" : "none" }}
      >
        <div className="modal-title">
          {props.title ?? "Title"}
          <img
            className="modal-close"
            onClick={props.onRequestClose}
            src={IconCloseImage}
            alt=""
          />
        </div>
      </div>
      <hr style={{ display: props.withHeader ? "block" : "none" }} />
      {props.children}
      <hr style={{ display: props.withFooter ? "block" : "none" }} />
      <div
        className="modal-footer"
        style={{ display: props.withFooter ? "flex" : "none" }}
      >
        <Button
          type="button"
          className="btn-outline-primary"
          style={{ marginRight: "8px" }}
          title={props.titleBtnOutline}
          onClick={props.onClikBtnOutline ?? props.onRequestClose}
        />
        <Button
          type="button"
          className="btn-danger"
          title={props.titleBtnInner}
          onClick={props.onClikBtnInner ?? props.onRequestClose}
        />
      </div>
    </Modal>
  );
};
export default CustomModalMaster;
